import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-co-holder',
    standalone: true,
    imports: [CoreModule, CommonModule, TranslateModule, SharedModule],
    templateUrl: './co-holder.component.html',
    styleUrl: './co-holder.component.scss'
})
export class CoHolderComponent {

    private appData = inject(AppService);

    continueButton = "common.buttons.continueButton";
    backButton = "common.buttons.backButton";

    coHolderTitle = "features.coHolder.coHolderTitle";
    coHolderSubtitle = "features.coHolder.coHolderSubtitle";

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    coHolderOptions: any[] = [
        { option: 'features.coHolder.optionAddCoHolder', description: 'features.coHolder.optionAddCoHolderDescription', key: 'S' },
        { option: 'features.coHolder.optionNoAddCoHolder', description: 'features.coHolder.optionNoAddCoHolderDescription', key: 'N' }
    ];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder
        ) {
            this.changeStepService.changeStep(2);
    }

    ngOnInit() {

        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe(value => {this.isPortraitDevice = value});

        this.createForm();
        this.setValuesForm(this.appData.data.userData);

        this.formIsValid();
    }

    createForm() {
        this.formGroup = this.fb.group({
            selectedCoHolderOption: new FormControl(null, [Validators.required])
        });
    }

    setValuesForm(value?:any) {
        if(value != undefined) {
            this.formGroup = this.fb.group({
                selectedCoHolderOption: new FormControl(value.coHolder.key ? value.coHolder.key : '', [Validators.required])
            });
        }
    }


    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    onChangeCoHolderSelection(item: any) {
        this.formGroup.controls.selectedCoHolderOption.setValue(item.key);

        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }


    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'co-holder');
        this.router.navigate(['/main/privacy-settings'], { relativeTo: this.route });
        /*
            //-DELETE
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/main/privacy-settings']);
          });
        */
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'co-holder');
        this.router.navigate(['/main/step/identification'], { relativeTo: this.route });
    }

    ngOnDestroy() {

    }
}
